export default __webpack_public_path__ + "static/media/Manyata.0ffcf88f.jpeg";